export default __webpack_public_path__ + "static/media/A4PosterLeftCropped.5d6fee74.png";